export default "__VITE_ASSET__DaI2xnX$__"